import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import ApiData from '@/assets/ApiData'
import AllLogs from '@/views/Logs'
import CustomerPage from '@/views/CustomerPage'
import * as Cookies from 'js-cookie';
import Templates from '@/views/EmailTemplate'



Vue.use(Router);



const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/templates',
            name:'templates',
            component: Templates
        },{
            path: '/logs',
            name:'logs',
            component: AllLogs
        },{
            path: '/customer/:id',
            name:'customer',
            component: CustomerPage
        }
     ],
});
router.beforeEach((to, from, next) => {
    // console.log('Global -- beforeEach - fired')

    // re-route
    if (to.path !== '/login') {
        ApiData.isAdminTokenValid()
            .then(data => {
                next()
            })
            .catch(data => {
                next('/login')
            });
    }
    else {
        next()
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js